/* eslint-disable no-underscore-dangle */
import { db, remoteConfig } from '@/shared/services/firebase'
import {getAreaGroups} from '@/shared/services/areaService'
import i18n from '@hw-core/libs/i18n'

export default {
  namespaced: true, // enable namespacing requires us to use  "<module name>/<action name>" to successfully dispatch an action
  state: {
    accounts: [],
    selectedAccount: null,
    areaGroups: [],
    germanRoles: [ // TODO not sure if roles should belong to account store module or should we rename account to avoid confusion with user account - the one who uses the web app
      {
        label: "Pflegefachkraft Stationär",
        canWorkAs: [
          "Pflegefachkraft Stationär"
        ]
      },
      {
        label: "Pflegefachkraft Häuslich",
        canWorkAs: [
          "Pflegefachkraft Häuslich"
        ]
      },
      {
        label: "Pflegekraft Stationär",
        canWorkAs: [
          "Pflegekraft Stationär"
        ]
      },
      {
        label: "Pflegekraft Häuslich",
        canWorkAs: [
          "Pflegekraft Häuslich"
        ]
      },
      {
        label: "Arzt",
        canWorkAs: [
          "Arzt"
        ]
      },
      {
        label: "Pflegehilfskraft Stationär",
        canWorkAs: [
          "Pflegehilfskraft Stationär"
        ]
      },
      {
        label: "Pflegehilfskraft Häuslich",
        canWorkAs: [
          "Pflegehilfskraft Häuslich"
        ]
      },
      {
        label: "Physiotherapeut",
        canWorkAs: [
          "Physiotherapeut"
        ]
      },
      {
        label: "Psychologe",
        canWorkAs: [
          "Psychologe"
        ]
      },
    ],
    roles: [
      {
        label: "sairaanhoitaja",
        canWorkAs: [
          "lähihoitaja",
          "sairaanhoitaja",
          "hoiva-avustaja"
        ]
      },
      {
        label: "lähihoitaja",
        canWorkAs: [
          "lähihoitaja",
          "hoiva-avustaja"
        ]
      },
      {
        label: "hoiva-avustaja",
        canWorkAs: [
          "hoiva-avustaja",
          "henkilökohtainen avustaja"
        ]
      },
      {
        label: "henkilökohtainen avustaja",
        canWorkAs: [
          "henkilökohtainen avustaja"
        ]
      },
      {
        label: "ensihoitaja",
        canWorkAs: [
          "lähihoitaja",
          "sairaanhoitaja",
          "ensihoitaja",
          "hoiva-avustaja",
          "henkilökohtainen avustaja"
        ]
      },
      {
        label: "lääkäri",
        canWorkAs: [
          "lääkäri",
          "lähihoitaja",
          "sairaanhoitaja",
          "ensihoitaja",
          "hoiva-avustaja",
          "henkilökohtainen avustaja"
        ]
      },
      {
        label: "rötgenhoitaja",
        canWorkAs: [
          "lähihoitaja",
          "sairaanhoitaja",
          "rötgenhoitaja"
        ]
      },
      {
        label: "kokki",
        canWorkAs: [
          "kokki"
        ],
        "oiwaOnly": true
      }
    ],
  },
  getters: {
    roleOptions: i18n.locale === 'de' ? state => state.germanRoles.map(role => role.label) : state => state.roles.map(role => role.label),
    userRole: state => value => {
      const roles = i18n.locale === 'de' ? state.germanRoles : state.roles
      const filteredArray = roles.filter(role => role.label === value)
      // eslint-disable-next-line no-nested-ternary
      const role = filteredArray.length ? filteredArray[0] : value.label ? value : { label: value.toLowerCase(), canWorkAs: [value.toLowerCase()] }
      return role
    },
  },
  mutations: {
    SET_USER_ACCOUNTS(state, accounts) {
      state.accounts = accounts
    },
    SET_USER_ACCOUNT(state, account) {
      state.selectedAccount = account
      localStorage.setItem('selectedAccount', JSON.stringify(account))
    },
    SET_ROLES(state, roles) {
      state.roles = roles
    },
    SET_AREA_GROUPS(state, areaGroups) {
      state.areaGroups = areaGroups
    },
    SET_REMOTE_CONFIG(state, val) {
      localStorage.setItem('webAdminClientVersion', val)
      state.webVersion = val
    },
  },
  actions: {
    getAccount(ctx, { accountId }) {
      return new Promise((resolve, reject) => {
        db.collection('accounts').doc(accountId).get()
          .then(doc => {
            const data = doc.data()
            data.id = doc.id
            const account = { label: data.name, value: data }
            ctx.dispatch('setUserAccount', account)
            ctx.dispatch('setUserAccounts', [account])
            resolve()
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    getAccounts(ctx) {
      return new Promise((resolve, reject) => {
        db.collection('accounts').orderBy('created').get()
          .then(async snapshot => {
            const accounts = snapshot.docs.map(doc => {
              const item = doc.data()
              item.id = doc.id
              return { label: item.name, value: item }
            }).sort((a, b) => (a.label > b.label ? 1 : -1))
            ctx.dispatch('setUserAccounts', accounts)
            if (localStorage.getItem('selectedAccount')) {
              const userData = JSON.parse(localStorage.getItem('selectedAccount'))
              const checkUser = accounts.find(account => account.value.id === userData.value.id)
              ctx.dispatch('setUserAccount', !checkUser ? accounts[0] : userData)
            } else {
              ctx.dispatch('setUserAccount', accounts[0])
            }
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    },
    fetchAreaGroups(ctx) {
      return new Promise((resolve, reject) => {
        getAreaGroups()
          .then(areaGroups => {
            ctx.commit('SET_AREA_GROUPS', areaGroups)
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    },
    setSelectedAccount(ctx, account) {
      ctx.dispatch('setUserAccount', account)
    },
    setUserAccounts(ctx, accounts) {
      return new Promise(resolve => {
        ctx.commit('SET_USER_ACCOUNTS', accounts)
        resolve()
      })
    },
    setUserAccount(ctx, account) {
      return new Promise(resolve => {
        ctx.commit('SET_USER_ACCOUNT', account)
        resolve()
      })
    },
    getRoles(ctx) {
      return new Promise((resolve, reject) => {
        remoteConfig.fetchAndActivate().then(() => {
          if (i18n.locale !== 'de') {
            const strRoles = remoteConfig.getValue('roles')._value
            if (strRoles) {
              const result = JSON.parse(strRoles)
              const { roles } = result
              const updatedRoles = roles.map(item => ({
                ...item,
                label: i18n.t(item.label)
              }))
              ctx.commit('SET_ROLES', updatedRoles)
            }
          }
          resolve()
        })
          .catch(() => {
            reject()
          })
      })
    },
    createAccount(ctx, account) {
      return new Promise((resolve, reject) => {
        db.collection('accounts').add(account)
          .then(() => {
            resolve()
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    getRemoteConfig(ctx) {
      setInterval(async () => {
        await remoteConfig.fetchAndActivate()
        const version = remoteConfig.getValue('webAdminClientVersion')._value
        const localVersion = localStorage.getItem('webAdminClientVersion')
        if (!localVersion || parseFloat(localVersion) < parseFloat(version)) {
          ctx.commit('SET_REMOTE_CONFIG', version)
        }
      }, remoteConfig.settings.fetchTimeoutMillis)
    },
  },

}
